export const ROVER_PROD_HOSTS = /^(www\.)?rover\.com$/;
export const ROVER_PR_STAGING_HOSTS = /^staging-pr-([-a-zA-Z0-9.]+)?roverstaging\.com$/;
export const ROVER_PR_WEBAPP_STAGING_HOSTS =
  /^staging-pr-([-a-zA-Z0-9.]+)?\.webapp\.roverstaging\.com$/;
export const ROVER_STAGING_HOSTS = /^([-a-zA-Z0-9.]+)?roverstaging\.com$/;
/**
 * Roverspaces (Coder) serve the app on the workspace's own Coder Connect FQDN,
 * `devcontainer.<workspace>.<owner>.coder`. `.coder` is Coder Connect's private
 * TLD, so matching the suffix is safe and survives a change of agent name.
 */
export const ROVER_ROVERSPACES_HOSTS = /^[-a-zA-Z0-9.]+\.coder$/;
export const ROVER_DEV_HOSTS = new RegExp(
  [/^rover\.local$/.source, ROVER_ROVERSPACES_HOSTS.source].join('|')
);
export const ROVER_HOSTS = new RegExp(
  [ROVER_PROD_HOSTS.source, ROVER_STAGING_HOSTS.source, ROVER_DEV_HOSTS.source].join('|')
);

export const CAT_IN_A_FLAT_PROD_HOSTS =
  /^(www\.)?catinaflat\.(de|at|be|fr|ie|nl|ch|co\.uk|com|es|ca)$/;
export const CAT_IN_A_FLAT_STAGING_HOSTS = /^([-a-zA-Z0-9.]+)?catinaflat\.dev$/;
export const CAT_IN_A_FLAT_PR_STAGING_HOSTS = /^staging-pr-([-a-zA-Z0-9.]+)?catinaflat\.dev$/;
export const CAT_IN_A_FLAT_DEV_HOSTS = /^((ciaf\.local))$/;
export const CAT_IN_A_FLAT_HOSTS = new RegExp(
  [
    CAT_IN_A_FLAT_PROD_HOSTS.source,
    CAT_IN_A_FLAT_STAGING_HOSTS.source,
    CAT_IN_A_FLAT_DEV_HOSTS.source,
  ].join('|')
);

export const DOG_BUDDY_PROD_HOSTS = /^(www\.|us\.)?dogbuddy\.com$/;
export const DOG_BUDDY_STAGING_HOSTS = /^([-a-zA-Z0-9.]+)?dogbuddy\.dev$/;

export const MADPAWS_PROD_HOSTS = /^(www\.)?madpaws\.com\.au$/;
export const MADPAWS_STAGING_HOSTS = /^([-a-zA-Z0-9.]+)?madpaws\.dev$/;
export const MADPAWS_PR_STAGING_HOSTS = /^staging-pr-([-a-zA-Z0-9.]+)?madpaws\.dev$/;
export const MADPAWS_DEV_HOSTS = /^((madpaws\.local))$/;
export const MADPAWS_HOSTS = new RegExp(
  [MADPAWS_PROD_HOSTS.source, MADPAWS_STAGING_HOSTS.source, MADPAWS_DEV_HOSTS.source].join('|')
);

/**
 * Matches production hosts for all Rover brands.
 */
export const BRAND_PROD_HOSTS = new RegExp(
  [
    ROVER_PROD_HOSTS.source,
    CAT_IN_A_FLAT_PROD_HOSTS.source,
    DOG_BUDDY_PROD_HOSTS.source,
    MADPAWS_PROD_HOSTS.source,
  ].join('|')
);

/**
 * Matches staging/preview hosts for all Rover brands.
 * Use this to decide whether to route to a staging Splunk index, toggle
 * staging-only behaviour, etc.
 */
export const BRAND_STAGING_HOSTS = new RegExp(
  [
    ROVER_STAGING_HOSTS.source,
    CAT_IN_A_FLAT_STAGING_HOSTS.source,
    MADPAWS_STAGING_HOSTS.source,
    DOG_BUDDY_STAGING_HOSTS.source,
  ].join('|')
);

export const LOCAL_HOSTS = /^(nginx)$/;
export const SYSTEM_HOSTS = new RegExp(
  [ROVER_HOSTS.source, LOCAL_HOSTS.source, CAT_IN_A_FLAT_HOSTS.source, MADPAWS_HOSTS.source].join(
    '|'
  )
);
